import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID,
    CONTEXT_MODIFIER_ARME_EN_ERREUR,
    CONTEXT_RETIRER_ARME_EN_ERREUR,
} from '../../../constants/apiUrls.constants';

const signalerErreur = combineReducers({
    recuperer: APIReducer.bind(null, CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID),
    retirerRatelier: APIReducer.bind(null, CONTEXT_RETIRER_ARME_EN_ERREUR),
    modifier: APIReducer.bind(null, CONTEXT_MODIFIER_ARME_EN_ERREUR),
});

export default signalerErreur;
